export * from './updateCardInfoDossier.component';
